import { createContext, useContext } from "react";

export interface SideNavOverride {
  collapsed?: boolean;
  disableExpand?: boolean;
}

interface SideNavOverrideContextType {
  override: SideNavOverride | null;
  setOverride: (override: SideNavOverride | null) => void;
}

export const SideNavOverrideContext = createContext<SideNavOverrideContextType>({
  override: null,
  setOverride: () => {},
});

export function useSideNavOverride() {
  return useContext(SideNavOverrideContext);
}
